import React, { useState } from 'react';
import Modal from '../common/modal';
import { Section } from '../common/section';
import { Translate, useTranslate } from '~/i18n';
import { ArrowRight, ItineraryWorldIcon, KaabaIcon, MapSaudiIcon } from '~/svgs';
import { Button } from '../common/button';
import { useRouter } from 'next/router';
import { useAuth } from '~/auth';
import Image from 'next/image';
import UpdateProfileTypeModal from '../incomplete-dashboard/onboard/update-profile-type-modal';

type DeleteProductModalType = {
   open: boolean;
   setOpen: (value: boolean) => void;
};

type ProductType = {
   title: React.ReactNode;
   description: React.ReactNode;
   icon: React.ReactNode;
   product_type: string;
   publish_on: 'vs' | 'nusuk';
};

const CreateProductModal = ({ open, setOpen }: DeleteProductModalType) => {
   const router = useRouter();
   const { lang } = useTranslate();
   const { user } = useAuth();
   const [openProfileTypeModal, setOpenProfileTypeModal] = useState(false);

   const ProductType: ProductType[] = [
      {
         title: <Translate id="createproduct:experiences" />,
         description: <Translate id="createproduct:experiences description" />,
         icon: (
            <>
               <ItineraryWorldIcon /> + <MapSaudiIcon />
            </>
         ),
         product_type: 'experiences',
         publish_on: 'vs',
      },
      // {
      //    title: <Translate id="createproduct:tours" />,
      //    description: <Translate id="createproduct:tours description" />,
      //    icon: <ItineraryWorldIcon />,
      //    product_type: 'tours',
      //    publish_on: 'vs',
      // },
      {
         title: <Translate id="createproduct:umrah" />,
         description: <Translate id="createproduct:umrah description" />,
         icon: <KaabaIcon />,
         product_type: 'umrah',
         publish_on: 'nusuk',
      },
   ];

   return (
      <Modal size="md" open={open} onClickOutside={() => setOpen(false)}>
         <Modal.Body>
            <Section className="rounded-2xl">
               <div className="px-8 py-6">
                  <div className="mb-1 text-2xl font-bold">
                     <Translate id="createproduct:create new product" />
                  </div>
                  <div className="text-sm text-grey-200">
                     <Translate id="createproduct:create new product description" />
                  </div>
               </div>
               <hr />
               <div className="px-8 py-8">
                  <div className="grid items-center w-full h-full grid-cols-1 gap-6 lg:grid-cols-2">
                     {ProductType?.map(
                        ({ icon, description, product_type, title, publish_on }, index) => (
                           <div
                              className="flex flex-col w-full h-full rounded-md bg-grey-600"
                              key={index}>
                              <div className="flex flex-col h-full p-6">
                                 <div className="flex items-center gap-1 mb-1 font-semibold">
                                    {icon}{' '}
                                 </div>
                                 <div className="mb-1 font-semibold">{title}</div>
                                 <div className="mb-8 text-xs text-grey-200">{description}</div>
                                 <Button
                                    theme="outline-primary"
                                    disabled={product_type != 'umrah' && user?.is_umrah}
                                    className="mt-auto"
                                    onClick={() => {
                                       router.push(
                                          `/${lang}/products/main-details?show_templates=false&product_type=${product_type}`
                                       );
                                    }}>
                                    <Translate id="createproduct:create product" />
                                    <ArrowRight className="w-2 ml-2 -mb-0.5 rtl:rotate-180 rtl:mr-2" />
                                 </Button>
                              </div>
                              <div className="flex items-center justify-between gap-4 px-6 py-3 mt-auto text-xs border-t border-grey-500">
                                 <Translate id="createproduct:published on" />
                                 <Image
                                    priority
                                    width={63}
                                    height={26}
                                    src={`/images/products/${publish_on}.svg`}
                                 />
                              </div>
                           </div>
                        )
                     )}
                  </div>
               </div>

               {user?.is_umrah && (
                  <>
                     <hr />
                     <div className="px-8 py-6">
                        <div className="text-sm text-grey-200">
                           <Translate id="createproduct:create product modal footer note" /> <br />
                           <span
                              className="cursor-pointer text-primary"
                              onClick={() => setOpenProfileTypeModal(true)}>
                              <Translate id="createproduct:manage account types" />
                           </span>
                        </div>
                     </div>
                  </>
               )}
            </Section>
         </Modal.Body>
         <UpdateProfileTypeModal
            open={openProfileTypeModal}
            setOpen={setOpenProfileTypeModal}
            refetchUser={() => {
               console.log('Refetch');
            }}
         />
      </Modal>
   );
};

export default CreateProductModal;
